import { Fragment } from "react";
import ReactDOM from "react-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  HiOutlineCheckCircle,
  HiOutlineExclamationCircle,
  HiXMark,
} from "react-icons/hi2";

import classes from "./AlertModal.module.css";
import Backdrop from "./Backdrop";
import { alertActions } from "../../store/alert-slice";

const Overlay = () => {
  const dispatch = useDispatch();
  const message = useSelector((state) => state.alert.message);
  const status = useSelector((state) => state.alert.status);
  const showModal = useSelector((state) => state.alert.showModal);

  const closeModalHandler = () => {
    dispatch(alertActions.resetState());
  };

  const variant = status === "success" ? classes.success : classes.error;
  const anim = showModal ? classes.enter : classes.leave;

  return (
    <div className={`${classes.alert} ${variant} ${anim}`} role="alert">
      <div className={classes.inner}>
        <button
          type="button"
          className={classes.close}
          onClick={closeModalHandler}
          aria-label="Dismiss notification"
        >
          <HiXMark className={classes.closeIcon} aria-hidden />
        </button>
        <div className={classes.iconWrap}>
          {status === "success" ? (
            <HiOutlineCheckCircle className={classes.icon} aria-hidden />
          ) : (
            <HiOutlineExclamationCircle className={classes.icon} aria-hidden />
          )}
        </div>
        <p className={classes.message}>{message}</p>
      </div>
    </div>
  );
};

const AlertModal = () => {
  const backdropRoot = document.getElementById("backdrop-root");
  const overlayRoot = document.getElementById("overlay-root");
  return (
    <Fragment>
      {ReactDOM.createPortal(<Backdrop />, backdropRoot)}
      {ReactDOM.createPortal(<Overlay />, overlayRoot)}
    </Fragment>
  );
};

export default AlertModal;
